<template>
  <div>
    <v-dialog v-model="dialog" transition="dialog-bottom-transition" scrollable max-width="500px">
      <v-card v-if="dialog">
        <v-card-title primary-title class="pa-0">
          <v-toolbar dark class="warning white--text">
            <v-toolbar-title>Protestar boleto</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon @click.native="$emit('closeDialog')" dark>
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
        </v-card-title>
        <v-card-text class="pa-3">
          <v-row class="pa-2">
            <v-alert type="warning" :value="true" class="my-5">
              <h4>O boleto será cancelado e a fatura será marcada como protestada. O cliente pode ser bloqueado.</h4>
            </v-alert>
          </v-row>
          <v-row class="justify-center">
            <b class="title">Deseja realmente protestar este boleto?</b>
          </v-row>
        </v-card-text>
        <v-card-actions class="justify-space-around">
          <f-btn cancel alt_text="Não" @click="$emit('closeDialog')">Não</f-btn>
          <f-btn save alt_text="Sim" alt_icon="mdi-gavel" :loading="loading" :disabled="loading" @click="confirmProtest">Sim</f-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: 'DialogProtestBill',
  props: {
    dialog: {
      type: Boolean,
      default: false
    },
    bill: {
      type: Object,
      default: null
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    confirmProtest() {
      this.$emit('confirm', this.bill)
    }
  }
}
</script>
